import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-6386">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-6387">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-6388">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-6389">
            <ArrowLeft className="w-4 h-4" data-id="element-6390" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-6391">NOIZA</div>
          <div className="w-20" data-id="element-6392" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-6393">
        <div className="mb-12" data-id="element-6394">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-6395">
            <FileText className="w-6 h-6 text-white/80" data-id="element-6396" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-6397">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-6398">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-6399">
          <section data-id="element-6400">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6401">
              <span className="text-[#006847]" data-id="element-6402">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6403">
              <p data-id="element-6404">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-6405">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6406">
                <li data-id="element-6407">Haber leído íntegramente este documento</li>
                <li data-id="element-6408">Comprender su contenido en su totalidad</li>
                <li data-id="element-6409">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-6410">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-6411">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6412">
              <span className="text-[#006847]" data-id="element-6413">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6414">
              <p data-id="element-6415">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6416">
                <li data-id="element-6417">Software como servicio (SaaS)</li>
                <li data-id="element-6418">Marketplace digital gastronómico</li>
                <li data-id="element-6419">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-6420">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6421">
                <li data-id="element-6422">Mostrar su menú digital</li>
                <li data-id="element-6423">Recibir pedidos de clientes</li>
                <li data-id="element-6424">Gestionar su operación interna</li>
                <li data-id="element-6425">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-6426">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-6427">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6428">
              <span className="text-[#006847]" data-id="element-6429">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6430">
              <p data-id="element-6431">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6432">
                <li data-id="element-6433">No es proveedor de alimentos</li>
                <li data-id="element-6434">No participa en la preparación de productos</li>
                <li data-id="element-6435">No manipula alimentos en ningún momento</li>
                <li data-id="element-6436">No realiza entregas ni logística</li>
                <li data-id="element-6437">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-6438">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-6439">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-6440">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6441">
              <span className="text-[#006847]" data-id="element-6442">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-6443">
              <p data-id="element-6444">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-6445">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6446">
                <li data-id="element-6447">El restaurante es el único responsable de su operación</li>
                <li data-id="element-6448">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-6449">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-6450">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6451">
                <li data-id="element-6452">Precios</li>
                <li data-id="element-6453">Menú</li>
                <li data-id="element-6454">Horarios</li>
                <li data-id="element-6455">Métodos de pago</li>
                <li data-id="element-6456">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6457">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6458">
              <span className="text-[#006847]" data-id="element-6459">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-6460">
              <div data-id="element-6461">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6462">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6463">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6464">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6465">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6466">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6467">
                  <li data-id="element-6468">Calidad de los alimentos</li>
                  <li data-id="element-6469">Estado, frescura o preparación</li>
                  <li data-id="element-6470">Ingredientes utilizados</li>
                  <li data-id="element-6471">Contaminación cruzada</li>
                  <li data-id="element-6472">Problemas de higiene o salubridad</li>
                  <li data-id="element-6473">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6474">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6475">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6476">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6477">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6478">
                  <li data-id="element-6479">Retrasos en la entrega</li>
                  <li data-id="element-6480">Pérdida de pedidos</li>
                  <li data-id="element-6481">Entregas incompletas</li>
                  <li data-id="element-6482">Errores en dirección</li>
                  <li data-id="element-6483">Conducta de repartidores</li>
                  <li data-id="element-6484">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6485">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6486">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6487">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6488">
                  <li data-id="element-6489">Recepción de pagos</li>
                  <li data-id="element-6490">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6491">Manejo de efectivo</li>
                  <li data-id="element-6492">Confirmación de pagos</li>
                  <li data-id="element-6493">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6494">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6495">
                  <li data-id="element-6496">Pagos no recibidos</li>
                  <li data-id="element-6497">Comprobantes falsos</li>
                  <li data-id="element-6498">Errores en montos</li>
                  <li data-id="element-6499">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6500">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6501">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6502">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6503">
                  <li data-id="element-6504">Reclamos de clientes</li>
                  <li data-id="element-6505">Reembolsos</li>
                  <li data-id="element-6506">Cancelaciones</li>
                  <li data-id="element-6507">Disputas</li>
                  <li data-id="element-6508">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6509">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6510">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6511">
              <span className="text-[#006847]" data-id="element-6512">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6513">
              <p data-id="element-6514">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6515">
                <li data-id="element-6516">Responsable</li>
                <li data-id="element-6517">Legal</li>
                <li data-id="element-6518">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6519">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6520">
                <li data-id="element-6521">Publicar información falsa</li>
                <li data-id="element-6522">Manipular precios de forma engañosa</li>
                <li data-id="element-6523">Simular disponibilidad inexistente</li>
                <li data-id="element-6524">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6525">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6526">
              <span className="text-[#006847]" data-id="element-6527">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6528">
              <p data-id="element-6529">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6530">
                <li data-id="element-6531">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6532">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6533">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6534">
                <li data-id="element-6535">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6536">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6537">
                    <li data-id="element-6538">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6539">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6540">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6541">
              <span className="text-[#006847]" data-id="element-6542">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6543">
              <p data-id="element-6544">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6545">
                <li data-id="element-6546">Menú digital</li>
                <li data-id="element-6547">Gestión de pedidos</li>
                <li data-id="element-6548">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6549">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6550">
                  <p className="font-medium text-white mb-2" data-id="element-6551">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6552">
                    <li data-id="element-6553">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6554">
                  <p className="font-medium text-white mb-2" data-id="element-6555">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6556">
                    <li data-id="element-6557">Propiedad del software</li>
                    <li data-id="element-6558">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6559">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6560">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6561">
              <span className="text-[#006847]" data-id="element-6562">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6563">
              <p data-id="element-6564">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6565">
                <li data-id="element-6566">Disponibilidad continua</li>
                <li data-id="element-6567">Funcionamiento sin interrupciones</li>
                <li data-id="element-6568">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6569">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6570">
                <li data-id="element-6571">Fallas técnicas</li>
                <li data-id="element-6572">Actualizaciones</li>
                <li data-id="element-6573">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6574">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6575">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6576">
              <span className="text-[#006847]" data-id="element-6577">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6578">
              <p data-id="element-6579">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6580">
                <li data-id="element-6581">No está garantizada permanentemente</li>
                <li data-id="element-6582">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6583">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6584">
                <li data-id="element-6585">Destacar o no restaurantes</li>
                <li data-id="element-6586">Modificar posiciones</li>
                <li data-id="element-6587">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6588">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6589">
              <span className="text-[#006847]" data-id="element-6590">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6591">
              <p data-id="element-6592">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6593">
                <li data-id="element-6594">Cumplir con los pagos acordados</li>
                <li data-id="element-6595">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6596">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6597">
                <li data-id="element-6598">Suspender el servicio</li>
                <li data-id="element-6599">Limitar funcionalidades</li>
                <li data-id="element-6600">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6601">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6602">
              <span className="text-[#006847]" data-id="element-6603">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6604">
              <p data-id="element-6605">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6606">
                <li data-id="element-6607">Incumplimiento de términos</li>
                <li data-id="element-6608">Uso indebido</li>
                <li data-id="element-6609">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6610">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6611">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6612">
              <span className="text-[#006847]" data-id="element-6613">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6614">
              <p data-id="element-6615">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6616">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6617">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6618">
              <span className="text-[#006847]" data-id="element-6619">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6620">
              <p data-id="element-6621">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6622">
                <li data-id="element-6623">Pérdidas económicas</li>
                <li data-id="element-6624">Daños indirectos</li>
                <li data-id="element-6625">Lucro cesante</li>
                <li data-id="element-6626">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6627">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6628">
              <span className="text-[#006847]" data-id="element-6629">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6630">
              <p data-id="element-6631">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6632">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6633">
              <span className="text-[#006847]" data-id="element-6634">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6635">
              <p className="font-medium" data-id="element-6636">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6637">
                <li data-id="element-6638">Ha leído este documento completo</li>
                <li data-id="element-6639">Comprende su alcance</li>
                <li data-id="element-6640">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}